"use client";

import React from "react";

//Styled
import * as S from "./styles";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

interface PaginationProps {
  pages: (number | string)[];
  currentPage: number;
  totalPages?: number;
  onClick?: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  pages = [],
  currentPage,
  totalPages,
  onClick,
}) => {
  const maxPage =
    totalPages ||
    Math.max(...(pages.filter((p) => typeof p === "number") as number[]));

  return (
    <S.Pagination>
      <S.PaginationItem onClick={() => onClick?.(1)}>
        <ChevronsLeft />
      </S.PaginationItem>

      <S.PaginationItem onClick={() => onClick?.(Math.max(currentPage - 1, 1))}>
        <ChevronLeft />
      </S.PaginationItem>

      {pages.map((page, index) => {
        const isNumber = typeof page === "number";
        return (
          <S.PaginationItem
            key={index}
            $active={isNumber && Number(page) === currentPage}
            onClick={() => isNumber && onClick?.(page)}
            $disabled={!isNumber}
          >
            {page}
          </S.PaginationItem>
        );
      })}

      <S.PaginationItem
        onClick={() => onClick?.(Math.min(currentPage + 1, maxPage))}
      >
        <ChevronRight />
      </S.PaginationItem>

      <S.PaginationItem onClick={() => onClick?.(maxPage)}>
        <ChevronsRight />
      </S.PaginationItem>
    </S.Pagination>
  );
};

export default Pagination;
